import { Box, Checkbox } from "@mui/material";
import { useBoundStore } from "useStore";

export default function AdsCheckboxHeader() {
  const adsEditedRows = useBoundStore((state) => state.adsEditedRows);
  const adsSelectionModel = useBoundStore((state) => state.adsSelectionModel);
  const setAdsSelectionModel = useBoundStore(
    (state) => state.setAdsSelectionModel,
  );

  const editedKeys = Object.keys(adsEditedRows);
  const allSelected =
    editedKeys.length > 0 &&
    editedKeys.every((k) => adsSelectionModel.includes(k));
  const someSelected =
    editedKeys.length > 0 &&
    editedKeys.some((k) => adsSelectionModel.includes(k)) &&
    !allSelected;

  const handleToggleAll = () => {
    if (allSelected) {
      setAdsSelectionModel(
        adsSelectionModel.filter((id) => !editedKeys.includes(id)),
      );
    } else {
      const newSelection = Array.from(
        new Set([...adsSelectionModel, ...editedKeys]),
      );
      setAdsSelectionModel(newSelection);
    }
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      <Checkbox
        checked={allSelected}
        indeterminate={someSelected}
        onChange={handleToggleAll}
        disabled={editedKeys.length === 0}
        sx={{
          p: 0,
          "&.Mui-checked": { color: "#002878" },
          "&.MuiCheckbox-indeterminate": { color: "#002878" },
        }}
      />
    </Box>
  );
}
